// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId_SUMMARY, ContentId_MIAB, ContentId_ACTIONABLE, ContentId_EXPERT_VIDEO, ContentId_QUICKWIN, ContentId_ONLINE_CONTENT, ContentIxStatus } from "../schema";
import { serialize_ContentId_SUMMARY_internal, deserialize_ContentId_SUMMARY_internal } from "./ContentId_SUMMARY";
import { serialize_ContentId_MIAB_internal, deserialize_ContentId_MIAB_internal } from "./ContentId_MIAB";
import { serialize_ContentId_ACTIONABLE_internal, deserialize_ContentId_ACTIONABLE_internal } from "./ContentId_ACTIONABLE";
import { serialize_ContentId_EXPERT_VIDEO_internal, deserialize_ContentId_EXPERT_VIDEO_internal } from "./ContentId_EXPERT_VIDEO";
import { serialize_ContentId_QUICKWIN_internal, deserialize_ContentId_QUICKWIN_internal } from "./ContentId_QUICKWIN";
import { serialize_ContentId_ONLINE_CONTENT_internal, deserialize_ContentId_ONLINE_CONTENT_internal } from "./ContentId_ONLINE_CONTENT";

export function serialize_ContentIxStatus_internal(value: ContentIxStatus): unknown {
  return ((
    value:
      | { contentType: "SUMMARY"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_SUMMARY; customerId: number; likedAt: DateTime<true> | null; readingProgress: number }
      | { contentType: "MIAB"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_MIAB; customerId: number; feedback: boolean | null; feedbackAt: DateTime<true> | null; modifiedAt: DateTime<true> }
      | {
          contentType: "ACTIONABLE";
          bookmarkedAt: DateTime<true> | null;
          contentId: ContentId_ACTIONABLE;
          customerId: number;
          experienceFeedbackScore: number | null;
          peerInsightProvidedAt: DateTime<true> | null;
          proTalkRequestedAt: DateTime<true> | null;
          proTalkVideoProgress: number | null;
          step2CompletedAt: DateTime<true> | null;
          step2Readiness: boolean;
          step2VideoProgress: number | null;
        }
      | { contentType: "EXPERT_VIDEO"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_EXPERT_VIDEO; customerId: number; modifiedAt: DateTime<true>; startedAt: DateTime<true> | null }
      | {
          contentType: "QUICKWIN";
          bookmarkedAt: DateTime<true> | null;
          completedAt: DateTime<true> | null;
          contentId: ContentId_QUICKWIN;
          customerId: number;
          modifiedAt: DateTime<true>;
          reshuffledAt: DateTime<true> | null;
          selectedAnswerIndex: number | null;
          startedAt: DateTime<true> | null;
        }
      | { contentType: "VERIFAI"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_ONLINE_CONTENT; customerId: number; modifiedAt: DateTime<true> },
  ): unknown => {
    switch (value.contentType) {
      case "SUMMARY": {
        return {
          contentType: "SUMMARY",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          consumedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["consumedAt"]),
          contentId: ((value: ContentId_SUMMARY): unknown => {
            return serialize_ContentId_SUMMARY_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          likedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["likedAt"]),
          readingProgress: ((value: number): unknown => {
            return value;
          })(value["readingProgress"]),
        };
      }
      case "MIAB": {
        return {
          contentType: "MIAB",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          contentId: ((value: ContentId_MIAB): unknown => {
            return serialize_ContentId_MIAB_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          feedback: ((value: boolean | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["feedback"]),
          feedbackAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["feedbackAt"]),
          modifiedAt: ((value: DateTime<true>): unknown => {
            return value.toMillis();
          })(value["modifiedAt"]),
        };
      }
      case "ACTIONABLE": {
        return {
          contentType: "ACTIONABLE",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          contentId: ((value: ContentId_ACTIONABLE): unknown => {
            return serialize_ContentId_ACTIONABLE_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          experienceFeedbackScore: ((value: number | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["experienceFeedbackScore"]),
          peerInsightProvidedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["peerInsightProvidedAt"]),
          proTalkRequestedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["proTalkRequestedAt"]),
          proTalkVideoProgress: ((value: number | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["proTalkVideoProgress"]),
          step2CompletedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["step2CompletedAt"]),
          step2Readiness: ((value: boolean): unknown => {
            return value;
          })(value["step2Readiness"]),
          step2VideoProgress: ((value: number | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["step2VideoProgress"]),
        };
      }
      case "EXPERT_VIDEO": {
        return {
          contentType: "EXPERT_VIDEO",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          contentId: ((value: ContentId_EXPERT_VIDEO): unknown => {
            return serialize_ContentId_EXPERT_VIDEO_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          modifiedAt: ((value: DateTime<true>): unknown => {
            return value.toMillis();
          })(value["modifiedAt"]),
          startedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["startedAt"]),
        };
      }
      case "QUICKWIN": {
        return {
          contentType: "QUICKWIN",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          completedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["completedAt"]),
          contentId: ((value: ContentId_QUICKWIN): unknown => {
            return serialize_ContentId_QUICKWIN_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          modifiedAt: ((value: DateTime<true>): unknown => {
            return value.toMillis();
          })(value["modifiedAt"]),
          reshuffledAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["reshuffledAt"]),
          selectedAnswerIndex: ((value: number | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["selectedAnswerIndex"]),
          startedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["startedAt"]),
        };
      }
      case "VERIFAI": {
        return {
          contentType: "VERIFAI",
          bookmarkedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["bookmarkedAt"]),
          consumedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["consumedAt"]),
          contentId: ((value: ContentId_ONLINE_CONTENT): unknown => {
            return serialize_ContentId_ONLINE_CONTENT_internal(value);
          })(value["contentId"]),
          customerId: ((value: number): unknown => {
            return value;
          })(value["customerId"]),
          modifiedAt: ((value: DateTime<true>): unknown => {
            return value.toMillis();
          })(value["modifiedAt"]),
        };
      }
    }
  })(value);
}
export function serialize_ContentIxStatus(obj: ContentIxStatus): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentIxStatus_internal(obj));
}
export function deserialize_ContentIxStatus_internal(value: unknown): ParserResult<ContentIxStatus> {
  return ((
    value: unknown,
  ): ParserResult<
    | { contentType: "SUMMARY"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_SUMMARY; customerId: number; likedAt: DateTime<true> | null; readingProgress: number }
    | { contentType: "MIAB"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_MIAB; customerId: number; feedback: boolean | null; feedbackAt: DateTime<true> | null; modifiedAt: DateTime<true> }
    | {
        contentType: "ACTIONABLE";
        bookmarkedAt: DateTime<true> | null;
        contentId: ContentId_ACTIONABLE;
        customerId: number;
        experienceFeedbackScore: number | null;
        peerInsightProvidedAt: DateTime<true> | null;
        proTalkRequestedAt: DateTime<true> | null;
        proTalkVideoProgress: number | null;
        step2CompletedAt: DateTime<true> | null;
        step2Readiness: boolean;
        step2VideoProgress: number | null;
      }
    | { contentType: "EXPERT_VIDEO"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_EXPERT_VIDEO; customerId: number; modifiedAt: DateTime<true>; startedAt: DateTime<true> | null }
    | {
        contentType: "QUICKWIN";
        bookmarkedAt: DateTime<true> | null;
        completedAt: DateTime<true> | null;
        contentId: ContentId_QUICKWIN;
        customerId: number;
        modifiedAt: DateTime<true>;
        reshuffledAt: DateTime<true> | null;
        selectedAnswerIndex: number | null;
        startedAt: DateTime<true> | null;
      }
    | { contentType: "VERIFAI"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_ONLINE_CONTENT; customerId: number; modifiedAt: DateTime<true> }
  > => {
    return ((
      value: unknown,
    ): ParserResult<
      | { contentType: "SUMMARY"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_SUMMARY; customerId: number; likedAt: DateTime<true> | null; readingProgress: number }
      | { contentType: "MIAB"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_MIAB; customerId: number; feedback: boolean | null; feedbackAt: DateTime<true> | null; modifiedAt: DateTime<true> }
      | {
          contentType: "ACTIONABLE";
          bookmarkedAt: DateTime<true> | null;
          contentId: ContentId_ACTIONABLE;
          customerId: number;
          experienceFeedbackScore: number | null;
          peerInsightProvidedAt: DateTime<true> | null;
          proTalkRequestedAt: DateTime<true> | null;
          proTalkVideoProgress: number | null;
          step2CompletedAt: DateTime<true> | null;
          step2Readiness: boolean;
          step2VideoProgress: number | null;
        }
      | { contentType: "EXPERT_VIDEO"; bookmarkedAt: DateTime<true> | null; contentId: ContentId_EXPERT_VIDEO; customerId: number; modifiedAt: DateTime<true>; startedAt: DateTime<true> | null }
      | {
          contentType: "QUICKWIN";
          bookmarkedAt: DateTime<true> | null;
          completedAt: DateTime<true> | null;
          contentId: ContentId_QUICKWIN;
          customerId: number;
          modifiedAt: DateTime<true>;
          reshuffledAt: DateTime<true> | null;
          selectedAnswerIndex: number | null;
          startedAt: DateTime<true> | null;
        }
      | { contentType: "VERIFAI"; bookmarkedAt: DateTime<true> | null; consumedAt: DateTime<true> | null; contentId: ContentId_ONLINE_CONTENT; customerId: number; modifiedAt: DateTime<true> }
    > => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/ContentIxStatus]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/ContentIxStatus]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "contentType")) {
        return { success: false, reason: `[#/components/schemas/ContentIxStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
      }
      if (typeof value["contentType"] != "string") {
        return { success: false, reason: `[#/components/schemas/ContentIxStatus]: '${value["contentType"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["contentType"];
      switch (discriminator) {
        case "SUMMARY": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            consumedAt: DateTime<true> | null;
            contentId: ContentId_SUMMARY;
            customerId: number;
            likedAt: DateTime<true> | null;
            readingProgress: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "consumedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/consumedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'consumedAt'.` };
            }
            const parsed_consumedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/consumedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/consumedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["consumedAt"]);
            })();
            if (!parsed_consumedAt.success) {
              return { success: false, reason: parsed_consumedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_SUMMARY> => {
              return ((value: unknown): ParserResult<ContentId_SUMMARY> => {
                return deserialize_ContentId_SUMMARY_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "likedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/likedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'likedAt'.` };
            }
            const parsed_likedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/likedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/likedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["likedAt"]);
            })();
            if (!parsed_likedAt.success) {
              return { success: false, reason: parsed_likedAt.reason };
            }
            if (!hasProp(value, "readingProgress")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/readingProgress]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'readingProgress'.` };
            }
            const parsed_readingProgress = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/SUMMARY/readingProgress]: '${value}' expected to be of type number or bigint.` };
              })(value["readingProgress"]);
            })();
            if (!parsed_readingProgress.success) {
              return { success: false, reason: parsed_readingProgress.reason };
            }
            return {
              success: true,
              value: {
                bookmarkedAt: parsed_bookmarkedAt.value,
                consumedAt: parsed_consumedAt.value,
                contentId: parsed_contentId.value,
                customerId: parsed_customerId.value,
                likedAt: parsed_likedAt.value,
                readingProgress: parsed_readingProgress.value,
              },
            };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "SUMMARY" as const, ...parsedVariant.value } };
        }
        case "MIAB": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            contentId: ContentId_MIAB;
            customerId: number;
            feedback: boolean | null;
            feedbackAt: DateTime<true> | null;
            modifiedAt: DateTime<true>;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_MIAB> => {
              return ((value: unknown): ParserResult<ContentId_MIAB> => {
                return deserialize_ContentId_MIAB_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "feedback")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/feedback]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'feedback'.` };
            }
            const parsed_feedback = ((): ParserResult<boolean | null> => {
              return ((value: unknown): ParserResult<boolean | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/feedback]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["feedback"]);
            })();
            if (!parsed_feedback.success) {
              return { success: false, reason: parsed_feedback.reason };
            }
            if (!hasProp(value, "feedbackAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/feedbackAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'feedbackAt'.` };
            }
            const parsed_feedbackAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/feedbackAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/feedbackAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["feedbackAt"]);
            })();
            if (!parsed_feedbackAt.success) {
              return { success: false, reason: parsed_feedbackAt.reason };
            }
            if (!hasProp(value, "modifiedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
            }
            const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
              return ((value: unknown): ParserResult<DateTime<true>> => {
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/modifiedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/MIAB/modifiedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["modifiedAt"]);
            })();
            if (!parsed_modifiedAt.success) {
              return { success: false, reason: parsed_modifiedAt.reason };
            }
            return {
              success: true,
              value: {
                bookmarkedAt: parsed_bookmarkedAt.value,
                contentId: parsed_contentId.value,
                customerId: parsed_customerId.value,
                feedback: parsed_feedback.value,
                feedbackAt: parsed_feedbackAt.value,
                modifiedAt: parsed_modifiedAt.value,
              },
            };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "MIAB" as const, ...parsedVariant.value } };
        }
        case "ACTIONABLE": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            contentId: ContentId_ACTIONABLE;
            customerId: number;
            experienceFeedbackScore: number | null;
            peerInsightProvidedAt: DateTime<true> | null;
            proTalkRequestedAt: DateTime<true> | null;
            proTalkVideoProgress: number | null;
            step2CompletedAt: DateTime<true> | null;
            step2Readiness: boolean;
            step2VideoProgress: number | null;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_ACTIONABLE> => {
              return ((value: unknown): ParserResult<ContentId_ACTIONABLE> => {
                return deserialize_ContentId_ACTIONABLE_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "experienceFeedbackScore")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/experienceFeedbackScore]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'experienceFeedbackScore'.` };
            }
            const parsed_experienceFeedbackScore = ((): ParserResult<number | null> => {
              return ((value: unknown): ParserResult<number | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/experienceFeedbackScore]: '${value}' expected to be of type number.` };
              })(value["experienceFeedbackScore"]);
            })();
            if (!parsed_experienceFeedbackScore.success) {
              return { success: false, reason: parsed_experienceFeedbackScore.reason };
            }
            if (!hasProp(value, "peerInsightProvidedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/peerInsightProvidedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'peerInsightProvidedAt'.` };
            }
            const parsed_peerInsightProvidedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/peerInsightProvidedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/peerInsightProvidedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["peerInsightProvidedAt"]);
            })();
            if (!parsed_peerInsightProvidedAt.success) {
              return { success: false, reason: parsed_peerInsightProvidedAt.reason };
            }
            if (!hasProp(value, "proTalkRequestedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/proTalkRequestedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'proTalkRequestedAt'.` };
            }
            const parsed_proTalkRequestedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/proTalkRequestedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/proTalkRequestedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["proTalkRequestedAt"]);
            })();
            if (!parsed_proTalkRequestedAt.success) {
              return { success: false, reason: parsed_proTalkRequestedAt.reason };
            }
            if (!hasProp(value, "proTalkVideoProgress")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/proTalkVideoProgress]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'proTalkVideoProgress'.` };
            }
            const parsed_proTalkVideoProgress = ((): ParserResult<number | null> => {
              return ((value: unknown): ParserResult<number | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/proTalkVideoProgress]: '${value}' expected to be of type number or bigint.` };
              })(value["proTalkVideoProgress"]);
            })();
            if (!parsed_proTalkVideoProgress.success) {
              return { success: false, reason: parsed_proTalkVideoProgress.reason };
            }
            if (!hasProp(value, "step2CompletedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2CompletedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step2CompletedAt'.` };
            }
            const parsed_step2CompletedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2CompletedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2CompletedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["step2CompletedAt"]);
            })();
            if (!parsed_step2CompletedAt.success) {
              return { success: false, reason: parsed_step2CompletedAt.reason };
            }
            if (!hasProp(value, "step2Readiness")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2Readiness]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step2Readiness'.` };
            }
            const parsed_step2Readiness = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2Readiness]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["step2Readiness"]);
            })();
            if (!parsed_step2Readiness.success) {
              return { success: false, reason: parsed_step2Readiness.reason };
            }
            if (!hasProp(value, "step2VideoProgress")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2VideoProgress]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step2VideoProgress'.` };
            }
            const parsed_step2VideoProgress = ((): ParserResult<number | null> => {
              return ((value: unknown): ParserResult<number | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/ACTIONABLE/step2VideoProgress]: '${value}' expected to be of type number or bigint.` };
              })(value["step2VideoProgress"]);
            })();
            if (!parsed_step2VideoProgress.success) {
              return { success: false, reason: parsed_step2VideoProgress.reason };
            }
            return {
              success: true,
              value: {
                bookmarkedAt: parsed_bookmarkedAt.value,
                contentId: parsed_contentId.value,
                customerId: parsed_customerId.value,
                experienceFeedbackScore: parsed_experienceFeedbackScore.value,
                peerInsightProvidedAt: parsed_peerInsightProvidedAt.value,
                proTalkRequestedAt: parsed_proTalkRequestedAt.value,
                proTalkVideoProgress: parsed_proTalkVideoProgress.value,
                step2CompletedAt: parsed_step2CompletedAt.value,
                step2Readiness: parsed_step2Readiness.value,
                step2VideoProgress: parsed_step2VideoProgress.value,
              },
            };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "ACTIONABLE" as const, ...parsedVariant.value } };
        }
        case "EXPERT_VIDEO": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            contentId: ContentId_EXPERT_VIDEO;
            customerId: number;
            modifiedAt: DateTime<true>;
            startedAt: DateTime<true> | null;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_EXPERT_VIDEO> => {
              return ((value: unknown): ParserResult<ContentId_EXPERT_VIDEO> => {
                return deserialize_ContentId_EXPERT_VIDEO_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "modifiedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
            }
            const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
              return ((value: unknown): ParserResult<DateTime<true>> => {
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/modifiedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/modifiedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["modifiedAt"]);
            })();
            if (!parsed_modifiedAt.success) {
              return { success: false, reason: parsed_modifiedAt.reason };
            }
            if (!hasProp(value, "startedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/startedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'startedAt'.` };
            }
            const parsed_startedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/startedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/EXPERT_VIDEO/startedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["startedAt"]);
            })();
            if (!parsed_startedAt.success) {
              return { success: false, reason: parsed_startedAt.reason };
            }
            return { success: true, value: { bookmarkedAt: parsed_bookmarkedAt.value, contentId: parsed_contentId.value, customerId: parsed_customerId.value, modifiedAt: parsed_modifiedAt.value, startedAt: parsed_startedAt.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "EXPERT_VIDEO" as const, ...parsedVariant.value } };
        }
        case "QUICKWIN": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            completedAt: DateTime<true> | null;
            contentId: ContentId_QUICKWIN;
            customerId: number;
            modifiedAt: DateTime<true>;
            reshuffledAt: DateTime<true> | null;
            selectedAnswerIndex: number | null;
            startedAt: DateTime<true> | null;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "completedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/completedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'completedAt'.` };
            }
            const parsed_completedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/completedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/completedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["completedAt"]);
            })();
            if (!parsed_completedAt.success) {
              return { success: false, reason: parsed_completedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_QUICKWIN> => {
              return ((value: unknown): ParserResult<ContentId_QUICKWIN> => {
                return deserialize_ContentId_QUICKWIN_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "modifiedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
            }
            const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
              return ((value: unknown): ParserResult<DateTime<true>> => {
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/modifiedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/modifiedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["modifiedAt"]);
            })();
            if (!parsed_modifiedAt.success) {
              return { success: false, reason: parsed_modifiedAt.reason };
            }
            if (!hasProp(value, "reshuffledAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/reshuffledAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reshuffledAt'.` };
            }
            const parsed_reshuffledAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/reshuffledAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/reshuffledAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["reshuffledAt"]);
            })();
            if (!parsed_reshuffledAt.success) {
              return { success: false, reason: parsed_reshuffledAt.reason };
            }
            if (!hasProp(value, "selectedAnswerIndex")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/selectedAnswerIndex]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'selectedAnswerIndex'.` };
            }
            const parsed_selectedAnswerIndex = ((): ParserResult<number | null> => {
              return ((value: unknown): ParserResult<number | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/selectedAnswerIndex]: '${value}' expected to be of type number.` };
              })(value["selectedAnswerIndex"]);
            })();
            if (!parsed_selectedAnswerIndex.success) {
              return { success: false, reason: parsed_selectedAnswerIndex.reason };
            }
            if (!hasProp(value, "startedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/startedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'startedAt'.` };
            }
            const parsed_startedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/startedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/QUICKWIN/startedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["startedAt"]);
            })();
            if (!parsed_startedAt.success) {
              return { success: false, reason: parsed_startedAt.reason };
            }
            return {
              success: true,
              value: {
                bookmarkedAt: parsed_bookmarkedAt.value,
                completedAt: parsed_completedAt.value,
                contentId: parsed_contentId.value,
                customerId: parsed_customerId.value,
                modifiedAt: parsed_modifiedAt.value,
                reshuffledAt: parsed_reshuffledAt.value,
                selectedAnswerIndex: parsed_selectedAnswerIndex.value,
                startedAt: parsed_startedAt.value,
              },
            };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "QUICKWIN" as const, ...parsedVariant.value } };
        }
        case "VERIFAI": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            bookmarkedAt: DateTime<true> | null;
            consumedAt: DateTime<true> | null;
            contentId: ContentId_ONLINE_CONTENT;
            customerId: number;
            modifiedAt: DateTime<true>;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "bookmarkedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/bookmarkedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bookmarkedAt'.` };
            }
            const parsed_bookmarkedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/bookmarkedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/bookmarkedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["bookmarkedAt"]);
            })();
            if (!parsed_bookmarkedAt.success) {
              return { success: false, reason: parsed_bookmarkedAt.reason };
            }
            if (!hasProp(value, "consumedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/consumedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'consumedAt'.` };
            }
            const parsed_consumedAt = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/consumedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/consumedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["consumedAt"]);
            })();
            if (!parsed_consumedAt.success) {
              return { success: false, reason: parsed_consumedAt.reason };
            }
            if (!hasProp(value, "contentId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
            }
            const parsed_contentId = ((): ParserResult<ContentId_ONLINE_CONTENT> => {
              return ((value: unknown): ParserResult<ContentId_ONLINE_CONTENT> => {
                return deserialize_ContentId_ONLINE_CONTENT_internal(value);
              })(value["contentId"]);
            })();
            if (!parsed_contentId.success) {
              return { success: false, reason: parsed_contentId.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "modifiedAt")) {
              return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
            }
            const parsed_modifiedAt = ((): ParserResult<DateTime<true>> => {
              return ((value: unknown): ParserResult<DateTime<true>> => {
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/modifiedAt]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ContentIxStatus/VERIFAI/modifiedAt]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["modifiedAt"]);
            })();
            if (!parsed_modifiedAt.success) {
              return { success: false, reason: parsed_modifiedAt.reason };
            }
            return { success: true, value: { bookmarkedAt: parsed_bookmarkedAt.value, consumedAt: parsed_consumedAt.value, contentId: parsed_contentId.value, customerId: parsed_customerId.value, modifiedAt: parsed_modifiedAt.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { contentType: "VERIFAI" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/ContentIxStatus]: '${discriminator}' expected to be one of 'SUMMARY, MIAB, ACTIONABLE, EXPERT_VIDEO, QUICKWIN, VERIFAI'.` };
      }
    })(value);
  })(value);
}
export function deserialize_ContentIxStatus(str: string): ParserResult<ContentIxStatus> {
  return deserialize_ContentIxStatus_internal(parseJsonWithNumbersAsBigint(str));
}
